import pricing from "../assets/data/pricing.json";

// Business rules of the company creation flow

export const ASSOCIATION = "ASSOCIATION";

export const CLASSIC = "classic";
export const EXPRESS = "express";

export const PROCEDURES = {
  [CLASSIC]: { label: "Classique", delay: "Environ 1 semaine" },
  [EXPRESS]: { label: "Express", delay: "Environ 3 jours" },
};

export const ASSOCIATION_DELAY = "Environ 1 mois";

export const isAssociation = (businessType) => businessType === ASSOCIATION;

export const hasExpress = (businessType) =>
  Boolean(pricing.creationExpress?.[businessType]);

// Falls back to the classic procedure when express is not offered
export const procedureFor = (businessType, procedure) =>
  procedure === EXPRESS && hasExpress(businessType) ? EXPRESS : CLASSIC;

export const creationPrice = (businessType, procedure) =>
  procedureFor(businessType, procedure) === EXPRESS
    ? pricing.creationExpress[businessType]
    : pricing.creation[businessType];

export const creationDelay = (businessType, procedure) =>
  isAssociation(businessType)
    ? ASSOCIATION_DELAY
    : PROCEDURES[procedureFor(businessType, procedure)].delay;

// Quantity-based visual identity services
export const quantityRule = (key) => pricing[key];

export const clampQuantity = (key, quantity) => {
  const { min, step } = quantityRule(key);
  const rounded = Math.round((Number(quantity) || 0) / step) * step;

  return Math.max(min, rounded);
};

// Label of the service being ordered, shown above the flow pages
const FLOW_LABELS = {
  domiciliation: "Domiciliation d'entreprise",
  admin: "Administration d'entreprise",
  juridique: "Suivi juridique",
  grh: "Gestion des ressources humaines",
  sales: "Relation client",
  management: "Gestion 360° (ERP)",
};

export const flowLabel = (cart) => {
  if (cart?.from === "creation") {
    const { businessType, procedure } = cart;

    if (!businessType) return "Création d'entreprise";
    if (isAssociation(businessType)) return "Création d'une association";

    const base = `Création d'une ${businessType}`;

    return procedure
      ? `${base} · Procédure ${PROCEDURES[
          procedureFor(businessType, procedure)
        ].label.toLowerCase()}`
      : base;
  }

  return FLOW_LABELS[cart?.from] || null;
};
